import { HTTP_METHODS } from "@/constants/HttpConstants";
import { IPlatformMetaResponse } from "@/types/platformMeta.types";
import { sendRequestToInterviewWithCredential } from "@/utils/request.utils";

// eslint-disable-next-line import/prefer-default-export
export const getPlatformMetaAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential<IPlatformMetaResponse>({
    method: HTTP_METHODS.GET,
    url: `/platform_meta/${interviewSlug}/`,
  });
